import { render, staticRenderFns } from "./PropertyDivisionCompanionAnimalSurvey.vue?vue&type=template&id=aab69fba"
import script from "./PropertyDivisionCompanionAnimalSurvey.vue?vue&type=script&lang=ts"
export * from "./PropertyDivisionCompanionAnimalSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports